/**
 *
 * @typedef {'m'} Breakpoint
 */
export const Breakpoint = Object.freeze({
  // XXXS: 'xxxs',
  // XXS: 'xxs',
  XS: 'xs',
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl',
  // XXL: 'xxl',
  XXXL: 'xxxl',
  CONFIGURATOR_L: 'l',
  CONFIGURATOR_XS: 'configurator-xs',
  CONFIGURATOR_VERTICAL_M: 'vertical-m',
  LANDSCAPE: 'landscape',
});

const Breakpoints = {
  // [Breakpoint.XXXS]: '20em',
  // [Breakpoint.XXS]: '23em',
  [Breakpoint.XS]: '35em',
  [Breakpoint.S]: '48em',
  [Breakpoint.M]: '50em',
  [Breakpoint.L]: '62em',
  [Breakpoint.XL]: '75em',
  // [Breakpoint.XXL]: '84em',
  [Breakpoint.XXXL]: '96em',
  [Breakpoint.LANDSCAPE]: { orientation: 'landscape' },
};

Breakpoints[Breakpoint.CONFIGURATOR_XS] = {
  minWidth: Breakpoints[Breakpoint.XS],
  orientation: 'landscape',
};

Breakpoints[Breakpoint.CONFIGURATOR_VERTICAL_M] = {
  minHeight: Breakpoints[Breakpoint.M],
};

export default Object.freeze(Breakpoints);
